import './NoCart.scss';

import React from 'react';

import { ROUTE_SCANBAT } from '@/common/constants';
import Header from '@/ebat/components/blocks/Scanbat/Common/Header/Header';
import Content from '@/ebat/components/blocks/Scanbat/NoCart/Content/Content';
import Footer from '@/ebat/components/blocks/Scanbat/NoCart/Footer/Footer';
import useScanbat from '@/ebat/components/pages/Scanbat/useScanbat';

import { NoCartDefaultProps, NoCartProptypes } from './NoCart.proptypes';

const NoCart = ({ disabled, isLoading, warehouse }) => {
  const { isDisabled, onRemoveWarehouse } = useScanbat({
    disabled,
    isLoading,
    warehouse,
  });

  return (
    <div className="wrapper wrapper--full">
      <Header
        className="scanbat-no-cart-page__header"
        disabled={isDisabled.disabled}
        link={ROUTE_SCANBAT}
        onRemoveWarehouse={onRemoveWarehouse}
        warehouse={warehouse}
      />
      <Content className="scanbat-no-cart-page__content" />
      <Footer
        className="scanbat-no-cart-page__footer"
        disabled={isDisabled.disabled}
        isLoading={isDisabled.loading}
        onRemoveWarehouse={onRemoveWarehouse}
      />
    </div>
  );
};

NoCart.defaultProps = {
  ...NoCartDefaultProps,
};

NoCart.propTypes = {
  ...NoCartProptypes,
};

export default NoCart;
